import React from 'react';
import { Regions, RegionsStates } from 'services/regions';

interface Props {
  data: Record<number, number>;
}

const getColor = (index: number) => {
  const colors = ['#3B82F6', '#8B5CF6', '#F59E0B', '#EC4899', '#10B981'];
  return colors[index] || '#3B82F6';
};

const RegionOverview = ({ data }: Props) => {
  const groupByRegion = (byRegion: Record<number, number>) => {
    const result: Record<string, number> = {};

    Regions.forEach((region) => {
      const key = region.value as keyof typeof RegionsStates;

      const states = RegionsStates[key] || [];

      const total = states.reduce((acc, state) => {
        return acc + (byRegion[state.value] || 0);
      }, 0);

      if (total > 0) {
        result[region.label] = total;
      }
    });

    return Object.entries(result)
      .map(([label, total]) => ({ label, total }))
      .sort((a, b) => b.total - a.total);
  };

  const regions = groupByRegion(data);
  const max = Math.max(...regions.map((r) => r.total), 1);

  return (
    <div>
      <h5 className="mb-3 d-flex align-items-center" style={{ gap: 8 }}>
        <i className="material-icons text-primary">bar_chart</i>
        <span>Por Região</span>
      </h5>
      {regions.map((item, index) => {
        const percentage = (item.total / max) * 100;

        return (
          <div key={item.label} style={{ marginBottom: 16 }}>
            <div className="d-flex justify-content-between mb-1">
              <span>{item.label}</span>
              <span>{item.total}</span>
            </div>

            <div className="progress" style={{ height: 8 }}>
              <div
                className="progress-bar"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: getColor(index),
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RegionOverview;
